const grey = {
    100: "#131a21",
    400: "#566473",
    600: "#aab2b9",
    800: "#ececed",
    900: "#7f8b95",
};

export default grey;
